<template>
  <div :dir="isCurrentLangRTL ? 'rtl' : 'ltr'">
    <div v-if="loading" class="d-flex justify-center py-4">
      <v-progress-linear
        indeterminate
        color="cyan"
        class="pa-0"
      ></v-progress-linear>
    </div>

    <v-card
      v-if="items && items.length > 0"
      :disabled="loading"
      flat
      class="pa-4"
      :key="activeLang"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="cyan"
        class="pa-0"
      ></v-progress-linear>
      
      <v-stepper
        class="pa-0"
        style="background: transparent"
        color="transparent"
        v-model="e6"
        flat
      >
        <v-stepper-items>
          <!-- مرحله اول: فیلدهای فرم -->
          <v-stepper-content class="pa-0" step="1">
            <v-card-title
              v-if="value && value.title"
              :style="{ color: colorComputed }"
              :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
            >
              {{ value.title }}
            </v-card-title>
            
            <v-card-subtitle
              v-if="value && value.description"
              :style="{ color: colorComputed }"
              :class="isCurrentLangRTL ? 'text-right' : 'text-left'"
            >
              {{ value.description }}
            </v-card-subtitle>

            <v-row class="pa-2">
              <v-col
                class="pa-1"
                cols="12"
                v-for="form in items.filter(
                  (item) => item.items[0].type !== 'textarea'
                )"
                :key="form.id"
              >
                <!-- اینپوت متنی -->
                <v-text-field
                  v-if="form.items[0].type === 'text'"
                  :class="[!isCurrentLangRTL ? 'force-ltr-input' : '']"
                  :label="form.items[0].optional ? `${form.label}*` : form.label"
                  :error="errorHandler[form.id] || null"
                  v-model="form.feedAction"
                  :background-color="colorComputed"
                  outlined
                  :error-messages="
                    form.items[0]?.setting?.max || form.items[0]?.setting?.min
                      ? hintHandler(
                          form.items[0]?.setting.min,
                          form.items[0]?.setting.max,
                          form.feedAction
                        )
                      : null
                  "
                  dense
                  :counter="form.items[0]?.setting?.max || undefined"
                  type="text"
                  :append-icon="form.action"
                  :rules="[
                    (v) =>
                      rules(v, form.items[0]?.setting?.regex?.value)?.test ||
                      v == null ||
                      rules(v, form.items[0]?.setting?.regex?.value).text,
                  ]"
                />

                <!-- اینپوت عددی -->
                <v-text-field
                  v-else-if="form.items[0].type === 'number'"
                  :class="[!isCurrentLangRTL ? 'force-ltr-input' : '']"
                  :label="form.items[0].optional ? `${form.label}*` : form.label"
                  :error="errorHandler[form.id] || null"
                  :background-color="colorComputed"
                  :counter="form.items[0]?.setting?.max || undefined"
                  :append-icon="form.action"
                  v-model="form.feedAction"
                  :error-messages="
                    form.items[0]?.setting?.max || form.items[0]?.setting?.min
                      ? hintHandler(
                          form.items[0]?.setting.min,
                          form.items[0]?.setting.max,
                          form.feedAction
                        )
                      : null
                  "
                  outlined
                  dense
                  type="number"
                  :rules="[
                    (v) =>
                      rules(v, form.items[0]?.setting?.regex?.value)?.test ||
                      v == null ||
                      rules(v, form.items[0]?.setting?.regex?.value).text,
                  ]"
                />

                <!-- انتخاب‌گر چندگزینه‌ای -->
                <v-combobox
                  v-else-if="form.items[0].type === 'select'"
                  v-model="form.feedAction"
                  :append-icon="form.action"
                  :error="errorHandler[form.id] || null"
                  outlined
                  :label="form.items[0].optional ? `${form.label}*` : form.label"
                  :placeholder="form.items[0].label || t('select')"
                  dense
                  :items="form.items[0].selectItems"
                  :background-color="colorComputed"
                  :class="[!isCurrentLangRTL ? 'force-ltr-input' : '']"
                />

                <!-- تقویم -->
                <custom-date-picker
                  v-else-if="form.items[0].type === 'date'"
                  backgroundColor="white"
                  :error="errorHandler[form.id] || null"
                  v-model="form.feedAction"
                  :label="form.items[0].optional ? `${form.label}*` : form.label"
                  outlined
                  dense
                  append-icon="mdi-calendar-month"
                />
              </v-col>

              <!-- تکست‌اریا -->
              <v-col
                class="pa-1"
                cols="12"
                v-for="form in items.filter(
                  (item) => item.items[0].type === 'textarea'
                )"
                :key="form.id"
              >
                <v-textarea
                  :error="errorHandler[form.id] || null"
                  :color="errorHandler[form.id] ? 'red' : colorComputed"
                  :background-color="colorComputed"
                  :counter="form.items[0]?.setting?.max || undefined"
                  :append-icon="form.action"
                  v-model="form.feedAction"
                  :error-messages="
                    form.items[0]?.setting?.max || form.items[0]?.setting?.min
                      ? hintHandler(
                          form.items[0]?.setting.min,
                          form.items[0]?.setting.max,
                          form.feedAction
                        )
                      : null
                  "
                  outlined
                  :label="form.items[0].optional ? `${form.label}*` : form.label"
                  dense
                  :rows="4"
                  :class="[!isCurrentLangRTL ? 'force-ltr-input' : '']"
                  :rules="[
                    (v) =>
                      rules(v, form.items[0]?.setting?.regex?.value)?.test ||
                      v == null ||
                      rules(v, form.items[0]?.setting?.regex?.value).text,
                  ]"
                />
              </v-col>
            </v-row>

            <v-card-actions class="my-2 d-flex align-center justify-end">
              <v-btn
                @click="
                  value.conform ? (emptyCheck() ? (e6 = 2) : null) : beforeSend()
                "
                elevation="0"
                :loading="loading"
                class="white--text"
                color="green"
              >
                {{ value.conform ? t("continue") : t("SUBMIT_FORM") }}
                <v-icon right v-if="isCurrentLangRTL">
                  {{ value.conform ? "mdi-menu-left" : "mdi-book-check" }}
                </v-icon>
                <v-icon right v-else>
                  {{ value.conform ? "mdi-menu-right" : "mdi-book-check" }}
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-stepper-content>

          <!-- مرحله دوم: دریافت شماره موبایل -->
          <v-stepper-content class="pa-0" :step="value.conform ? '2' : '4'">
            <v-card
              color="transparent"
              class="pa-0 d-flex flex-column justify-center align-center w-100"
              flat
            >
              <v-card-title :style="{ color: colorComputed }">
                {{ t("enter_phone_number") }}
              </v-card-title>
              
              <v-text-field
                :background-color="colorComputed"
                outlined
                type="number"
                dense
                v-model="conformNumber"
                :class="[!isCurrentLangRTL ? 'force-ltr-input' : '']"
                :rules="[
                  (v) =>
                    !!v ||
                    v == null ||
                    rules(v, 'mobile').test ||
                    rules(v, 'mobile').text,
                ]"
              />

              <v-card-actions class="d-flex justify-space-around align-center w-100">
                <v-btn
                  elevation="0"
                  @click="e6 = 1"
                  class="white--text"
                  color="red"
                >
                  <v-icon left>{{ isCurrentLangRTL ? "mdi-menu-right" : "mdi-menu-left" }}</v-icon>
                  {{ t("back") }}
                </v-btn>
                <v-btn
                  elevation="0"
                  :disabled="!rules(conformNumber, 'mobile').test"
                  class="white--text"
                  color="green"
                  @click="e6 = 3"
                >
                  {{ t("continue") }}
                  <v-icon right>{{ isCurrentLangRTL ? "mdi-menu-left" : "mdi-menu-right" }}</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <!-- مرحله سوم: دریافت کد تایید (OTP) -->
          <v-stepper-content step="3" class="pa-0">
            <v-card
              class="pa-0 d-flex flex-column justify-center align-center w-100"
              flat
              color="transparent"
            >
              <v-card-subtitle :style="{ color: colorComputed }">
                {{ t("Enter_the_sent_code") }}
              </v-card-subtitle>
              
              <v-card
                flat
                color="transparent"
                class="pa-0 d-flex justify-center"
                max-width="300px"
                dir="ltr"
              >
                <v-otp-input
                  :length="4"
                  dir="ltr"
                  v-model="otp"
                  :disabled="loading"
                />
              </v-card>

              <v-card-actions class="d-flex justify-start">
                <v-btn
                  elevation="0"
                  @click="e6 = 2"
                  class="white--text"
                  color="red"
                >
                  <v-icon left>{{ isCurrentLangRTL ? "mdi-menu-right" : "mdi-menu-left" }}</v-icon>
                  {{ t("back") }}
                </v-btn>
                <v-btn
                  elevation="0"
                  :disabled="!otp || otp.toString().length !== 4"
                  class="white--text"
                  color="green"
                  @click="otpHandler"
                >
                  {{ t("Confirm_code") }}
                  <v-icon right>{{ isCurrentLangRTL ? "mdi-menu-left" : "mdi-menu-right" }}</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <!-- مرحله چهارم: پیام موفقیت -->
          <v-stepper-content :step="value.conform ? '4' : '2'">
            <v-card flat class="pa-2 text-center" color="transparent">
              <v-card-title
                class="d-flex justify-center pa-0"
                :style="{ color: colorComputed }"
              >
                {{ t("form_success_message") }}
              </v-card-title>

              <v-card-actions class="d-flex justify-center">
                <v-btn
                  :loading="loading"
                  class="white--text"
                  @click="
                    e6 = 1;
                    fetch();
                  "
                  color="orange"
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{ t("refill_form_message") }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import customDatePicker from "../../../core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";

export default {
  name: "consultationNewShowCell_multilang",

  components: { customDatePicker },

  props: {
    currentLang: {
      type: String,
      default: "fa",
    },
    lang: {
      type: String,
      default: "fa",
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    color: String,
  },

  data() {
    return {
      items: [],
      otp: "",
      errorHandler: {},
      loading: false,
      e6: 1,
      regex: {
        persian: /^[\u0600-\u06FF\s]+$/,
        number: /^\d+$/,
        english: /^[a-zA-Z\s]+$/,
        mixPerEng: /^[a-zA-Z0-9\u0600-\u06FF\s]+$/,
        email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        mobile: /^09\d{9}$/,
        meliCode: /^\d{10}$/,
        site: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)([\w.,@?^=%&:\/~+#-]*[\w@?^=%&\/~+#-])?$/,
      },
      conformNumber: null,
      formId: null,
    };
  },

  computed: {
    ...mapState("local", ["qr_id", "qrInfo", "change"]),
    
    activeLang() {
      return this.currentLang || this.lang || "fa";
    },

    isCurrentLangRTL() {
      const rtlLangs = ["fa", "ar", "he", "ur"];
      return rtlLangs.includes(this.activeLang);
    },

    domainName() {
      return this.$route?.params?.name;
    },

    qrId() {
      return this.$route?.params?.id?.replace("?gateway=true", "");
    },

    colorComputed() {
      return this.color || this.value?.sectionColor?.text;
    },
  },

  watch: {
    change() {
      this.fetch();
    },
  },

  mounted() {
    this.fetch();
  },

  methods: {
    t(key, args) {
      if (this.$i18n && typeof this.$i18n.t === "function") {
        return this.$i18n.t(key, this.activeLang, args);
      }
      return key;
    },

    fetch() {
      const QRID = this.qr_id;
      this.loading = true;
      this.$api
        .get(`application/forms/answer?qr_id=${QRID}`)
        .then(({ data }) => {
          if (!data?.data?.data || !Array.isArray(data?.data?.data)) {
            return;
          }

          const action = data.data.data.filter((item) => item.items[0].action);
          data.data.data.forEach((item) => {
            this.errorHandler = { ...this.errorHandler, [item.id]: false };
          });

          this.formId = data.data.id;
          this.items = action;
        })
        .catch((err) => console.log(err))
        .finally(() => (this.loading = false));
    },

    rules(v, type) {
      const regex = this.regex;

      switch (type) {
        case "persian":
          return { test: regex[type].test(v), text: this.t("persian_error") };
        case "number":
          return { test: regex[type].test(v), text: this.t("number_error") };
        case "english":
          return { test: regex[type].test(v), text: this.t("english_error") };
        case "mixPerEng":
          return { test: regex[type].test(v), text: this.t("mixPerEng_error") };
        case "email":
          return { test: regex[type].test(v), text: this.t("email_error") };
        case "mobile":
          return { test: regex[type].test(v), text: this.t("mobile_error") };
        case "meliCode":
          return { test: regex[type].test(v), text: this.t("meliCode_error") };
        case "site":
          return { test: regex[type].test(v), text: this.t("site_error") };
        default:
          return {
            test: false,
            text: this.t("default_error"),
          };
      }
    },

    hintHandler(min, max, val) {
      const leng = typeof val === "string" ? val?.length : val;
      let message = null;

      if (min !== undefined && leng < min) {
        message = this.t("min_length_error", { min });
      }

      if (max !== undefined && leng > max) {
        message = this.t("max_length_error", { max });
      }

      return message;
    },

    otpHandler() {
      console.log(this.otp);
    },

    beforeSend() {
      const readInputCheck = this.emptyCheck();
      let awnsers = {};

      if (readInputCheck) {
        this.items.forEach((item) => {
          if (item.feedAction && item.feedAction.length > 0) {
            awnsers = { ...awnsers, [item.title]: item.feedAction };
          }
        });

        this.sendData(awnsers);
      }
    },

    sendData(val) {
      this.loading = true;
      try {
        this.$api
          .post("/application/forms/answer/store", {
            form_id: this.formId,
            answer: val,
          })
          .then(() => {
            if (this.$toast && this.$toast.success) {
              this.$toast.success(this.t("form_submitted_message"));
            }
            this.e6 += 1;
          })
          .finally(() => (this.loading = false));
      } catch (err) {
        this.loading = false;
      }
    },

    emptyCheck() {
      let readInputCheck = true;
      this.items.forEach((item) => {
        const isOptional = item.items[0]?.optional;
        const hasFeedAction = item.feedAction && item.feedAction.length > 0;
        const isValid = !isOptional || hasFeedAction;

        this.errorHandler[item.id] = !isValid;
        readInputCheck = readInputCheck && isValid;
      });

      if (readInputCheck) {
        return readInputCheck;
      } else {
        if (this.$toast && this.$toast.error) {
          this.$toast.error(this.t("required_fields_error"));
        }
        return false;
      }
    },
  },
};
</script>

<style scoped>
/* اعمال تنظیمات چپ‌چین کامل برای فیلدها در حالت انگلیسی */
.force-ltr-input ::v-deep input,
.force-ltr-input ::v-deep textarea {
  text-align: left !important;
  direction: ltr !important;
}

.force-ltr-input ::v-deep .v-label {
  left: 0 !important;
  right: auto !important;
  transform-origin: top left !important;
  text-align: left !important;
}

.force-ltr-input ::v-deep .v-messages {
  text-align: left !important;
}

.force-ltr-input ::v-deep legend {
  text-align: left !important;
}
</style>
